import {invokeApi} from '../bl_libs/invokeApi';

export const registerRatingFingerprintService = (fingerprint_id) => {
    let requestObj = {
        path   : '/pdq3/public/rating/fingerprint/register',
        method : 'POST'
    };
    requestObj['postData'] = {
        fingerprint_id
    };

    return invokeApi(requestObj);
}

export const fetchRatingFingerprintService = (fingerprint_id) => {
    let requestObj = {
        path   : '/pdq3/public/rating/fingerprint/fetch',
        method : 'POST'
    };
    requestObj['postData'] = {
        fingerprint_id
    };

    return invokeApi(requestObj);
}

export const uploadMedia = (formData, progressCb) => {
    let requestObj = {
        path   : '/pdq3/public/rating/upload/content',
        method : 'POST',
        headers : {
            'content-type': 'multipart/form-data'
        },
        onUploadProgress: progressCb
    };
    requestObj['postData'] = formData

    return invokeApi(requestObj);
}

export const submitProgramDataPublicService = (fingerprint_id, files_path) => {
    let requestObj = {
        path   : '/pdq3/public/rating/submit/program/data',
        method : 'POST',
    };
    requestObj['postData'] = {
        fingerprint_id,
        files_path
    };

    return invokeApi(requestObj);
}

export const updateCompanyInfoPublicService = (fingerprint_id, data) => {
    let requestObj = {
        path   : '/pdq3/public/rating/update/info/company',
        method : 'POST',
    };
    requestObj['postData'] = {
        fingerprint_id,
        ...data
    };

    return invokeApi(requestObj);
}

export const updateProgramInfoPublicService = (fingerprint_id, data) => {
    let requestObj = {
        path   : '/pdq3/public/rating/update/info/program',
        method : 'POST',
    };
    requestObj['postData'] = {
        fingerprint_id,
        ...data
    };

    return invokeApi(requestObj);
}